import { ChangeDetectorRef, Component, inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FileUploadModel } from '@adgate/common/services/network-service';

@Component({
  selector: 'app-upload-progress-dialog-component',
  imports: [
    CommonModule,
    MatDialogModule,
    MatProgressBarModule
  ],
  templateUrl: './upload-progress-dialog-component.html',
  styleUrl: './upload-progress-dialog-component.scss',
})
export class UploadProgressDialogComponent implements OnInit, OnDestroy
{
  private dialogRef: MatDialogRef<UploadProgressDialogComponent> = inject(MatDialogRef<UploadProgressDialogComponent>);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  private zone: NgZone = inject(NgZone);
  public data: FileUploadModel = inject(MAT_DIALOG_DATA);

  private intervalId: any;

  ngOnInit(): void
  {
    // Poll for progress updates and trigger change detection
    this.zone.runOutsideAngular(() => {
      this.intervalId = setInterval(() => {
        this.zone.run(() => {
          this.cdr.detectChanges();
        });
      }, 100); // Check every 100ms
    });
  }

  ngOnDestroy(): void
  {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  onCancel(): void
  {
    this.dialogRef.close(false);
  }

  getTotalSize(): number
  {
    return Math.round(this.data.data.size / (1024 * 1024) );
  }

  getUploadedSize(): number
  {
    return Math.round(this.data.uploadedSize / (1024 * 1024) );
  }
}
